// extracted by mini-css-extract-plugin
module.exports = {"marketing-text-card":"MarketingTextCard_marketing-text-card__KbV4Q","marketing-text-card--non-primary":"MarketingTextCard_marketing-text-card--non-primary___4uP4"};